import { Component, computed, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ICON_DEFINITIONS } from './icon.definitions';

@Component({
  selector: 'app-icon',
  template: `
    <div class="flex items-center justify-center">
      <fa-icon [icon]="faIcon()" [className]="classes()" />
    </div>
  `,
  imports: [FontAwesomeModule],
})
export class IconComponent {
  icon = input.required<keyof typeof ICON_DEFINITIONS>();

  faIcon = computed(() => ICON_DEFINITIONS[this.icon()]);
  classes = input<string>('');
}
